<template>
  <div class="auhorcenter">
    <div class="t-nav">
      <nav>
        <ul class="r-nav">
          <li class="active"><a href="#">认证中心</a></li>
        </ul>
      </nav>
    </div>
    <div class="author">
      <h1>认证中心<el-button class="gotoauthor" type="danger" plain @click="showauthor">前去认证</el-button></h1>
      <br>
      <p><span>认证须知</span></p>
      <ul>
        <li><p>根据<span>《遥感影像公开使用管理规定（试行）》</span>规定,购买优于10米的数据需要进行客户信息登记</p></li>
        <li><p>完成企业或个人认证后,才能购买或下载数据</p></li>
        <li><p>如有问题请及时联系客服,热线:&nbsp;<span>010-82376552</span></p></li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'authorcenter',
  components: {
  },
  data () {
    return {

    }
  },
  methods: {
    showauthor () {
      this.$emit('showauthor')
    }
  }
}
</script>

<style lang="less">
.auhorcenter{
  margin-left: 200px;
  padding-left: 30px;
  background-color: #fff;
  min-height: 500px;
  .t-nav {
    nav{
      border-bottom: 2px solid #ddd;
      ul {
        margin-right: 150px;
        height: 60px;
        color: #b4b8bb;
        li{
          float: left;
          height: 60px;
          line-height: 60px;
          font-size: 15px;
          margin-right: 45px;
          a{
            color:#b4b8bb;
          }
        }
        li.active,li:hover {
          border-bottom: 2px solid #f01400;
          a{
            color:#f01400;
          }
        }
      }
    }
  }
  .author{
    h1{
      margin-top: 15px;
      overflow: hidden;
      color: #333;
      line-height: 30px;
      font-size: 18px;
      height: 40px;
      .gotoauthor{
        float: right;
        margin-right: 300px;
      }
    }
    p {
      font-size: 12px;
      line-height: 2.5em;
      span{
        color: red;
      }
    }
    ul{
      padding-left: 20px;
      li{
        list-style: disc;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/userCenter/authorcenter.vue